<template>
  <div>
    <div
      v-if="loader"
      class="fixed inset-0 flex items-center justify-center bg-white z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class="w-[500px]"
      />
    </div>
    <div class="flex flex-col items-center justify-center w-full h-full bg-white mt-2.5 md:mt-6.5">
      <div
        v-if="list.length === 0"
        class="flex flex-col sm:w-[520px] h-mx-auto"
      >
        <div class="grid grid-cols-1 gap-4 p-2 min-h-screen">
          <div class="flex flex-col justify-center items-center">
            <img src="@/assets/imgs/undraw_people_ka7y2.svg" alt="">
            <span class="flex justify-center items-center text-lg font-normal text-center my-6">
              No tienes prospectos agregados, te invitamos a que agregues a tus prospectos
            </span>
            <router-link
              :to="{ name: 'leads-add' }"
              class="flex items-center text-sm font-medium space-x-2 text-white bg-tuin-100 hover:bg-tuin_hover p-2 rounded-lg"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5.5C10.2652 5.5 10.5196 5.60536 10.7071 5.79289C10.8946 5.98043 11 6.23478 11 6.5V9.5H14C14.2652 9.5 14.5196 9.60536 14.7071 9.79289C14.8946 9.98043 15 10.2348 15 10.5C15 10.7652 14.8946 11.0196 14.7071 11.2071C14.5196 11.3946 14.2652 11.5 14 11.5H11V14.5C11 14.7652 10.8946 15.0196 10.7071 15.2071C10.5196 15.3946 10.2652 15.5 10 15.5C9.73478 15.5 9.48043 15.3946 9.29289 15.2071C9.10536 15.0196 9 14.7652 9 14.5V11.5H6C5.73478 11.5 5.48043 11.3946 5.29289 11.2071C5.10536 11.0196 5 10.7652 5 10.5C5 10.2348 5.10536 9.98043 5.29289 9.79289C5.48043 9.60536 5.73478 9.5 6 9.5H9V6.5C9 6.23478 9.10536 5.98043 9.29289 5.79289C9.48043 5.60536 9.73478 5.5 10 5.5Z" fill="white"/>
              </svg>
              <span class="ml-2">Agregar</span>
            </router-link>
          </div>
        </div>
      </div>
      <div v-else class="w-full max-w-6xl">
        <div class="flex flex-col sm:flex-row justify-end items-center gap-2 mt-4">
          <button
            class="flex items-center text-sm font-medium space-x-2 text-white bg-tuin-100 hover:bg-tuin_hover p-2 rounded-lg"
            @click="addProspect('new')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5.5C10.2652 5.5 10.5196 5.60536 10.7071 5.79289C10.8946 5.98043 11 6.23478 11 6.5V9.5H14C14.2652 9.5 14.5196 9.60536 14.7071 9.79289C14.8946 9.98043 15 10.2348 15 10.5C15 10.7652 14.8946 11.0196 14.7071 11.2071C14.5196 11.3946 14.2652 11.5 14 11.5H11V14.5C11 14.7652 10.8946 15.0196 10.7071 15.2071C10.5196 15.3946 10.2652 15.5 10 15.5C9.73478 15.5 9.48043 15.3946 9.29289 15.2071C9.10536 15.0196 9 14.7652 9 14.5V11.5H6C5.73478 11.5 5.48043 11.3946 5.29289 11.2071C5.10536 11.0196 5 10.7652 5 10.5C5 10.2348 5.10536 9.98043 5.29289 9.79289C5.48043 9.60536 5.73478 9.5 6 9.5H9V6.5C9 6.23478 9.10536 5.98043 9.29289 5.79289C9.48043 5.60536 9.73478 5.5 10 5.5Z" fill="white"/>
            </svg>
            <span class="ml-2">Agregar</span>
          </button>
        </div>
        <!-- Tabla de Prospectos -->
        <div class="bg-white mt-4 sm:mt-6 w-full">
          <!-- Componente Kanban Board -->
          <KanbanBoard 
            :leads="list" 
            :statuses="statuses"
            @lead-click="handleLeadClick"
            @status-updated="handleStatusUpdated"
          />
      <!--
        <div
          class="relative overflow-x-auto shadow-md rounded-lg t w-full h-screen"
        >
        <table class="table-auto w-full text-left">
          <thead class="uppercase bg-[#ff4265] text-[#e5e7eb] text-sm">
            <tr>
              
              <th class="py-2 px-4 border text-center font-bold sm:hidden">Nombre completo</th>
              <th class="py-2 px-4 border text-center font-bold hidden sm:table-cell">Nombre</th>
              <th class="py-2 px-4 border text-center font-bold hidden sm:table-cell">Apellidos</th>
              <th class="py-2 px-4 border text-center font-bold hidden sm:table-cell">Email</th>
              <th class="py-2 px-4 border text-center font-bold hidden sm:table-cell">Teléfono</th>
              <th class="py-2 px-4 border text-center font-bold">Contactar</th>
              <th class="py-2 px-4 border text-center font-bold">&nbsp;</th>
            </tr>
          </thead>
          <tbody class="bg-white text-[#646464]">
            <tr v-for="(row, index) in list" v-show="list.length > 0" :key="index">
              
              <td class="py-2 px-4 border sm:hidden">
                {{ row.name }} {{ row.last_name }} {{ row.second_last_name }}
              </td>

              
              <td class="py-2 px-4 border hidden sm:table-cell">{{ row.name }}</td>
              <td class="py-2 px-4 border hidden sm:table-cell">{{ row.last_name }} {{ row.second_last_name }}</td>

              
              <td class="py-2 px-4 border hidden sm:table-cell">{{ row.email }}</td>
              <td class="py-2 px-4 border hidden sm:table-cell">{{ row.phone }}</td>

              <td class="py-2 px-4 border text-center flex flex-wrap gap-2 justify-center">
                <a :href="`tel:+52${row.phone}`">
                  <button class="bg-tuin_base-0 p-2 text-white rounded-lg">
                    <img src="@/assets/imgs/icons/phone.svg" alt="Teléfono" class="w-5 h-5" />
                  </button>
                </a>
                <a :href="`https://wa.me/52${row.phone}?text=Hola%20${row.name}`" target="_blank">
                  <button class="bg-tuin_base-0 p-2 text-white rounded-lg">
                    <img src="@/assets/imgs/icons/wp.svg" alt="Whatsapp" class="w-5 h-5" />
                  </button>
                </a>
              </td>

              <td class="py-2 px-4 border text-center">
                <fwb-dropdown placement="left">
                  <template #trigger>
                    <img src="@/assets/imgs/icons/points.png" alt="Opciones" class="cursor-pointer w-6 h-6" />
                  </template>
                  <fwb-list-group>
                    <fwb-list-group-item
                      class="cursor-pointer hover:bg-tuin_base-0 hover:text-white"
                      @click="addProspect('edit', row.id)"
                    >
                      Editar
                    </fwb-list-group-item>
                    <fwb-list-group-item
                      class="cursor-pointer hover:bg-tuin_base-0 hover:text-white"
                      @click="AssignProperty(row.id)"
                    >
                      Asignar propiedad
                    </fwb-list-group-item>
                    <fwb-list-group-item
                      class="cursor-pointer hover:bg-tuin_base-0 hover:text-white"
                      @click="ModalConfirmDelete(row.id)"
                    >
                      Eliminar
                    </fwb-list-group-item>
                  </fwb-list-group>
                </fwb-dropdown>
              </td>
            </tr>
            <tr v-show="list.length == 0">
              <td colspan="6" class="text-center py-4">
                <div class="m-6 flex justify-center items-center">
                  Aún no has dado de alta prospectos.
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </div> -->
        </div>
      </div>
    </div>

    <LeadFormView
      v-if="mostrarModal"
      :lead-id="prospectId"
      :is-show-modal="mostrarModal"
      @cerrar="CloseFormModal"
    />

    <ModalPropertiesComponent
      v-if="mostrarModalProperties"
      :prospect-id="prospectId"
      @close="ClosePropertiesModal"
    />
  </div>
</template>

<script setup>
//import LoaderTuin from "@/commond/LoaderTuin.vue";
import LeadFormView from "@/components/leads/LeadFormView.vue";
import ModalPropertiesComponent from "@/components/leads/Modal/ModalPropertiesComponent.vue";
import KanbanBoard from "@/components/leads/KanbanBoard.vue";

//import InfoGralComponent from "@/components/leads/InfoGralComponent.vue";
import axios from "axios";
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";

import { useStore } from "vuex";
const store = useStore();
const router = useRouter();
let session = computed(() => store.getters.getUserSession);

let loader = ref(false);
let list = ref([]);
const statuses = [
  { name: 'Pendiente de contactar', status: '1' },
  { name: 'En proceso', status: '2' },
  { name: 'Finalizado', status: '3' },
  { name: 'No aplica', status: '4' },
  { name: 'Perdido', status: '5' },
  { name: 'Descartado', status: '6' },
];
let formModalOpen = ref(false);
let prospectId = ref("");

let mostrarModal = ref(false);
let mostrarModalProperties = ref(false);

function addProspect(action, prospect_id) {
  if (action == "new") {
    // Navegar a la nueva ruta para crear prospecto
    router.push({ name: 'leads-add' });
    return;
  }
  
  if (action == "edit") {
    // Navegar a la ruta de edición
    router.push({ name: 'leads-detail', params: { prospect_id } });
    return;
  }

  mostrarModal.value = true;
}

// Manejar clics en los leads del kanban
function handleLeadClick(lead) {
  addProspect('edit', lead.id);
}

// Manejar actualización de estado desde el kanban
function handleStatusUpdated({ leadId, newStatusId }) {
  // Actualizar el estado local del lead
  const leadIndex = list.value.findIndex(lead => lead.id === leadId);
  if (leadIndex !== -1) {
    // Buscar el objeto status correspondiente
    const newStatus = statuses.find(status => status.status === newStatusId);
    if (newStatus) {
      list.value[leadIndex].status = {
        id: newStatusId,
        name: newStatus.name
      };
    }
  }
}

/*function ModalConfirmDelete() {
  console.log("debe confirmar la eliminación");
}

function AssignProperty(leadId) {
  mostrarModalProperties.value = true;
  prospectId.value = leadId;
}*/

function CloseFormModal(isUpdate = false) {
  formModalOpen.value = 0;
  prospectId.value = "";
  mostrarModal.value = false;
  if (isUpdate) {
    loader.value = true;
    getLeads();
  }
}

async function getLeads() {
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/leads/${session.value.id}`,
      options
    );

    if (response.status == 401) {
      store.dispatch("clearUserSession");
    }

    if (response.status == 200) {
      list.value = response.data.resp;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }

  loader.value = false;
}

function ClosePropertiesModal() {
  mostrarModalProperties.value = false;
}

onMounted(async () => {
  loader.value = true;
  await getLeads();
});
</script>

<style scoped>
.icon-svg {
  font-size: #fff;
}
</style>
